export default {
	methods: {
		invoiceFreqLongLabel(freq) {
			if (!freq || typeof freq !== 'string') return '-'
			if (freq.startsWith('week_')) {
				const parts = freq.split('_')
				const n = parseInt(parts[1], 10)
				if (n === 1) return 'Wekelijks'
				if (!isNaN(n)) return `${n} weken`
			}
			switch (freq) {
				case 'month': return 'Maandelijks'
				case 'quarter': return 'Per kwartaal'
				case 'halfyear': return 'Halfjaarlijks'
				case 'year': return 'Jaarlijks'
				default: return freq
			}
		},

		invoiceFreqShortLabel(freq) {
			if (!freq || typeof freq !== 'string') return '-'
			if (freq.startsWith('week_')) {
				const parts = freq.split('_')
				const n = parseInt(parts[1], 10)
				if (n === 1) return 'Wekelijks'
				if (!isNaN(n)) return `${n} weken`
			}
			switch (freq) {
				case 'month': return 'Maand'
				case 'quarter': return 'Kwartaal'
				case 'halfyear': return 'Halfjaar'
				case 'year': return 'Jaar'
				default: return freq
			}
		}
	}
}
